import { createFileRoute, useParams, Link } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { QueryBoundary } from '@/components/query-boundary';
import { EmptyState } from '@/components/empty-state';
import { PortfolioForm } from '@/components/forms/PortfolioForm';
import { Button } from '@/components/ui/button';
import { usePortfolioList, useUpdatePortfolio } from '@/lib/queries/portfolio';
import { ChevronLeft } from 'lucide-react';
import { toast } from 'sonner';

export const Route = createFileRoute('/portfolio/$id')({ component: EditPortfolio });

function EditPortfolio() {
  const { id } = useParams({ from: '/portfolio/$id' });
  const list = usePortfolioList();
  const update = useUpdatePortfolio(id);

  return (
    <>
      <div className="mb-3">
        <Button variant="ghost" size="sm" asChild className="-ml-2 text-muted-foreground">
          <Link to="/content" search={{ tab: 'portfolio', status: 'all', q: '', days: 30 }}>
            <ChevronLeft /> 포트폴리오
          </Link>
        </Button>
      </div>
      <PageHeader title="포트폴리오 편집" description={id} />
      <QueryBoundary query={list}>
        {rows => {
          const row = (rows ?? []).find(r => r.id === id);
          if (!row) return (
            <EmptyState title="항목을 찾을 수 없습니다." description="목록으로 돌아가 다시 선택해 주세요." />
          );
          return (
            <PortfolioForm initial={row} submitLabel="저장" onSubmit={async v => {
              try { await update.mutateAsync(v); toast.success('저장됨'); }
              catch (e) { toast.error((e as Error).message); }
            }} />
          );
        }}
      </QueryBoundary>
    </>
  );
}
